/**
 * Questions
 */
const elements = document.querySelectorAll('.question');
elements.forEach(element => {
  element.addEventListener('click', () => {
    console.log('Element with class "myClass" was clicked!');
    // Add your custom logic here
    $(this).toggleClass("open");
    if ($("#resultsList").length) {
      if ($("#resultsList").height() < $("#theResults aside").height()) {
        $("#resultsList").css("min-height", $("#theResults aside").height());
      }
    }
  });
});